<template>
  <navigation-button
    class="customer-read-edit"
    icon="pen"
    label="Editar cliente"
    :href="href"
  />
</template>

<script>
  import NavigationButton from '@/components/Navigation/Button.vue';

  export default {
    name: 'CustomerReadEdit',
    components: {
      NavigationButton,
    },
    computed: {
      href() {
        const {
          id,
        } = this.$route.params;

        if (id) {
          return {
            name: 'customers-edit',
            params: {
              id: this.$route.params.id,
            },
          };
        }

        return {};
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';
</style>
